import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef } from 'react';
import { IconButton } from './Button';
import { Icon } from './Icon';
import { cx } from './cx';
/**
 * Nur für destruktive oder verzweigende Entscheidungen; alles andere inline.
 * Esc und Klick auf den Hintergrund schließen, der Fokus geht danach zurück.
 */
export function Dialog({ open, title, onClose, children, footer }) {
    const titelId = useId();
    const ref = useRef(null);
    // onClose in einer Ref: Ein inline übergebener Callback ist bei jedem Rendern
    // neu — stünde er in den Effekt-Abhängigkeiten, setzte der Dialog bei jedem
    // Tastendruck im Formular den Fokus zurück.
    const schliessen = useRef(onClose);
    schliessen.current = onClose;
    useEffect(() => {
        if (!open)
            return;
        const vorher = document.activeElement;
        ref.current?.focus();
        const taste = (e) => {
            if (e.key === 'Escape')
                schliessen.current();
            // Fokus im Dialog halten (Tab am Ende springt zum Anfang und umgekehrt).
            if (e.key === 'Tab' && ref.current) {
                const ziele = ref.current.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
                const erstes = ziele[0];
                const letztes = ziele[ziele.length - 1];
                if (!erstes || !letztes)
                    return;
                if (e.shiftKey && document.activeElement === erstes) {
                    e.preventDefault();
                    letztes.focus();
                }
                else if (!e.shiftKey && document.activeElement === letztes) {
                    e.preventDefault();
                    erstes.focus();
                }
            }
        };
        window.addEventListener('keydown', taste);
        return () => {
            window.removeEventListener('keydown', taste);
            vorher?.focus?.();
        };
    }, [open]);
    if (!open)
        return null;
    return (_jsx("div", { className: "one-backdrop", onMouseDown: (e) => e.target === e.currentTarget && onClose(), children: _jsxs("div", { ref: ref, className: "one-dialog", role: "dialog", "aria-modal": "true", "aria-labelledby": titelId, tabIndex: -1, children: [_jsxs("div", { className: "one-dialog-head", children: [_jsx("h2", { className: "one-dialog-title", id: titelId, children: title }), _jsx(IconButton, { icon: "x", label: "Schlie\u00DFen", size: "sm", onClick: onClose })] }), _jsx("div", { className: "one-dialog-body", children: children }), footer && _jsx("div", { className: "one-dialog-foot", children: footer })] }) }));
}
/** Schwebende Liste (Aufklappmenü). Positionieren und Öffnen übernimmt der Aufrufer. */
export function Menu({ items, head, className }) {
    return (_jsxs("div", { className: cx('one-menu', className), role: "menu", children: [head && _jsx("div", { className: "one-menu-head", children: head }), items.map((item, i) => item === 'separator' ? (_jsx("div", { className: "one-menu-sep", role: "separator" }, `sep-${i}`)) : (_jsxs("button", { type: "button", role: "menuitem", className: "one-menu-item", "data-active": item.active ? 'true' : undefined, onClick: item.onSelect, children: [item.icon && _jsx(Icon, { name: item.icon }), item.label] }, item.id)))] }));
}
